/** Direction enum, can be used in calculation directly */
export var ESLCarouselDirection;
(function (ESLCarouselDirection) {
    ESLCarouselDirection[ESLCarouselDirection["NEXT"] = 1] = "NEXT";
    ESLCarouselDirection[ESLCarouselDirection["NONE"] = 0] = "NONE";
    ESLCarouselDirection[ESLCarouselDirection["PREV"] = -1] = "PREV";
})(ESLCarouselDirection || (ESLCarouselDirection = {}));
